import React, { useMemo, useState } from "react"

import { Chip } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { LabelColor, LabelType } from "@cirrus/common/constants/label"

import { LabelsContainer } from "./styled"
import { ILabelsProps } from "./types"
import { Tooltip } from "../../atoms"

export const Labels = ({ labels, collapsedLength = 3, onDelete }: ILabelsProps) => {

  const { i18n } = useTranslations()
  const [isCollapsed, setIsCollapsed] = useState(labels.length > collapsedLength)

  const sortedLabels = useMemo(() => [...labels].sort((a, b) => {
    if (a?.type === LabelType.PERSONAL) return -1
    if (b?.type === LabelType.PERSONAL) return 1
    return 0
  }), [labels])

  const visibleLabels = isCollapsed ? sortedLabels.slice(0, collapsedLength) : sortedLabels

  return <LabelsContainer>
    {visibleLabels.map(({ id, title, type }) => <Tooltip key={id} title={`${title ?? id}`}>
      <Chip
        style={{ maxWidth: "130px" }}
        variant="outlined"
        color={LabelColor[type]}
        label={title}
        size="small"
        onDelete={!!onDelete ? (event) => {
          event.stopPropagation()
          onDelete({ id, title, type })
        } : undefined}
      />
    </Tooltip>)}

    {sortedLabels.length > collapsedLength && (
      <span className="toggle-button" onClick={(event) => {
        event.stopPropagation()
        setIsCollapsed((prev) => !prev)
      }}>
				{isCollapsed ? <Tooltip
          title={i18n("General:ShowMore")}>+{labels.length - collapsedLength}</Tooltip> : i18n("General:ShowLess")}
			</span>)}
  </LabelsContainer>
}
